exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".import-model,.import-sku{position:relative}.import-model:before,.import-sku:before{content:\"M\";color:#fff;font-weight:700;position:absolute;left:0;right:0;font-size:10px;top:calc(50% - 5px)}.import-sku:before{content:\"S\"}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f95dc3d6","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/List.vue
// module id = ReTr
// module chunks = 83